/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import ViewModel, { ViewModelArgs } from "./ViewModel";

export default abstract class DataViewModel<TState extends {}> extends ViewModel<TState> {
    protected readonly _setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    protected readonly _loading: boolean;

    constructor(args: ViewModelArgs<TState>) {
        super(args);
        [this._loading, this._setLoading] = useState<boolean>(true);
    }

    public get loading() {
        return this._loading;
    }

    protected abstract onDatenGeladen(data: unknown): void;

    protected readonly queryOnCompleted = (data: unknown) => {
        if (data) {
            this.onDatenGeladen(data);
        }

        this._setLoading(false);
        this.hideCoffeeMug();
    };
}